<template>
    <div style="display:flex">
      <router-link :to="{ name: 'Login' }" type="button" class="button secondary register">
        <svg viewBox="0 0 24 24" fill="none">
       <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9ZM12 20.5C13.784 20.5 15.4397 19.9504 16.8069 19.0112C17.4108 18.5964 17.6688 17.8062 17.3178 17.1632C16.59 15.8303 15.0902 15 11.9999 15C8.90969 15 7.40997 15.8302 6.68214 17.1632C6.33105 17.8062 6.5891 18.5963 7.19296 19.0111C8.56018 19.9503 10.2159 20.5 12 20.5Z"/>
      </svg>
        Giriş Yap</router-link>
      <router-link :to="{ name: 'Register' }" type="button" class="button primary">
        <svg version="1.1" id="Layer_1" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"> <path d="M93.1,325.8V139.6H46.5C20.9,139.6,0,160.5,0,186.2v279.3C0,491.1,20.9,512,46.5,512h279.3c25.7,0,46.5-20.9,46.5-46.5  v-46.5H186.2C134.8,418.9,93.1,377.2,93.1,325.8z M465.5,0H186.2c-25.7,0-46.5,20.9-46.5,46.5v279.3c0,25.7,20.9,46.5,46.5,46.5  h279.3c25.7,0,46.5-20.9,46.5-46.5V46.5C512,20.9,491.1,0,465.5,0z M442.2,209.5h-93.1v93.1h-46.5v-93.1h-93.1v-46.5h93.1V69.8h46.5  v93.1h93.1V209.5z"/> </svg>
        Kayıt Ol</router-link>
    </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import SocialMedia from '../SocialMedia'
  import Register from '../../../views/Auth/Register'

  export default{
    name: "DesktopGuest",
    data(){
      return{
        //is_login_error: false,
        registerModal: false,
        form:{
          username: null,
          password: null,
        }
      }
    },
    computed:{
      ...mapState("auth", ["isLoading"])
    },
    methods:{
      ...mapActions("auth", ["login"]),

      handleLogin() {
        this.login(this.form);
      }
    },
    components:{
      SocialMedia,
      Register
    },
    watch:{
      /*is_login_error(val){
        if(val){
          setTimeout(() => {
            this.is_login_error = false;
          },3000);
        }
      }*/
    }
  }
  
</script>